<div class="container-fluid">
  <div class="row">
    <div class="col-4"></div>
    <div class="col-4 form-check d-flex align-items-baseline justify-content-center">
      <!--
      <div class="p-0 custom-control custom-checkbox">
        <app-ui-checkbox [isChecked]="false" label="Add discount in:" (checked)="setDiscountOn($event)"></app-ui-checkbox>
      </div>
      <div class="form-check form-check-inline p-0 m-0 custom-control-inline custom-control custom-radio">
        <input (input)="changeDiscount(discountInput.value)" #discountInput [disabled]="!discountEnabled" type="number" step="0.1" [min]="0" [max]="100" class="form-control-sm border-0 bg-light w-70-px mb-3 ml-2" [ngClass]="{'cursor-not-allowed': !discountEnabled}" placeholder="00.00" />
      </div>
      %
      -->
    </div>
    <div class="col-4 pr-0 d-flex align-items-baseline justify-content-end">
      <table class="table-sm">
        @if (discountEnabled && discountOnPrice > 0) {
          <tr>
            <td>
              <div class="text-right text-color-brand">{{discountOnPrice}}% <ng-container>Discount</ng-container>:</div>
            </td>
            <td class="text-right">
              <div class="font-weight-bold text-color-brand">{{ totalPrice * (discountOnPrice / 100) | currency: CURRENCY: 'symbol': undefined: 'de-CH' }}</div>
            </td>
          </tr>
        }
        <tr>
          <td>
            <div class="text-right"><ng-container i18n="@@app.price_without_vat">Price without VAT</ng-container>:</div>
          </td>
          <td class="text-right">
            <div class="font-weight-bold">{{ totalPrice | totalPrice:null:discountOnPrice:discountEnabled | currency: CURRENCY: 'symbol': undefined: 'de-CH'}}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="text-right">{{ VAT * 100}}% <ng-container i18n="@@app.vat">VAT</ng-container>:</div>
          </td>
          <td class="text-right">
            <div class="font-weight-bold">{{ (( totalPrice | totalPrice:null:discountOnPrice:discountEnabled) * VAT ) | currency: CURRENCY: 'symbol': undefined: 'de-CH'}}</div>
          </td>
        </tr>
        <tr class="border-top">
          <td>
            <div class="text-right">
              <ng-container i18n="@@app.total_price">Total price</ng-container>* (<ng-container i18n="@@app.vat_included">VAT included</ng-container>):</div>
            </td>
            <td class="text-right">
              <div class="font-weight-bold">{{ totalPrice | totalPrice:VAT:discountOnPrice:discountEnabled | currency: CURRENCY: 'symbol': undefined: 'de-CH'}}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
